import { ReactComponent as LogoIcon } from 'assets/icons/logo.svg';

function Logo() {
  return <LogoIcon />;
}

export default Logo;
